import {Component, Inject, Input} from '@angular/core';
import {MxButtonModel} from './mx-button.model';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../../../shared/services/mx-translate.service';


@Component({
    selector: 'mx-button',
    standalone: false,
    templateUrl: './mx-button.component.html',
    styleUrls: ['./mx-button.component.scss']
})
export class MxButtonComponent {

    @Input()
    public buttonModel: MxButtonModel;

    public constructor(@Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) { }

    onClick(): void {
        if (this.buttonModel.clickHandler) {
            this.buttonModel.clickHandler();
        }
    }

    public getHidden ? = (): boolean => {
        return (typeof this.buttonModel.hidden === 'function') ? this.buttonModel.hidden() : this.buttonModel.hidden;
    };

    public getDisabled ? = (): boolean => {
        return (typeof this.buttonModel.disabled === 'function') ? this.buttonModel.disabled() : this.buttonModel.disabled;
    };

    public getLabel ? = (): string => {
        return (typeof this.buttonModel.label === 'function')
            ? this.buttonModel.label()
            : this.translateService.getTranslatedLabel(this.buttonModel.label);
    };

    public isLabelButton = (): boolean => {
        return (this.buttonModel.label && this.buttonModel.label.length > 0)
            || typeof this.buttonModel.label === 'function';
    };

    public getTooltip ? = (): string => {
        return (typeof this.buttonModel.tooltip === 'function')
            ? this.buttonModel.tooltip()
            : this.translateService.getTranslatedLabel(this.buttonModel.tooltip);
    };
}
